import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.research.performance',
    'package:data.universal.orgStructure.withDivisions', // FIXME: should not be included, but some widgets seem to require it
    'resource:solutions.apps.rp.pages.explore',
    'resource:solutions.apps.rp.pages.overview',
    'resource:solutions.apps.rp.pages.trends',
    'resource:solutions.apps.rp',
    'resource:solutions.mosaic.pages.rp.explore',
    'resource:solutions.mosaic.pages.rp.overviewWithPiScatter',
    'resource:solutions.mosaic.pages.rp.trends',
    'resource:solutions.mosaic.widgets.rp.exploreMetrics',
    'resource:solutions.mosaic.widgets.rp.explorePerfComparison',
    'resource:solutions.mosaic.widgets.rp.exploreTrends',
    'resource:solutions.mosaic.widgets.rp.orgTable',
    'resource:solutions.mosaic.widgets.rp.overviewDonut',
    'resource:solutions.mosaic.widgets.rp.overviewMetrics',
    'resource:solutions.mosaic.widgets.rp.overviewTrends',
    'resource:solutions.mosaic.widgets.rp.piScatter',
    'resource:solutions.mosaic.widgets.rp.piTable',
    'resource:solutions.mosaic.widgets.rp.projectsTable',
    'resource:solutions.mosaic.widgets.rp.spaceTable',
    'resource:solutions.mosaic.widgets.rp.sponsorsTable',
    'resource:solutions.mosaic.widgets.rp.trendsStacked',
    'resource:solutions.mosaic.widgets.rp.trendsTable',
  ],
  description: 'Standard Research Performance',
  name: 'RP',
} as const satisfies core.quiver.Package
